import { api } from './api';

const BATCH_SIZE = 10;

/** Never retry an ambiguous execution or continue after a transport failure. */
export async function approveActionBatches(ids, {
  isCurrent = () => true, onBatch, onProgress,
} = {}) {
  if (!ids.length || new Set(ids).size !== ids.length) {
    throw new Error('Select at least one action, without duplicates.');
  }
  const results = [];
  for (let offset = 0; offset < ids.length && isCurrent(); offset += BATCH_SIZE) {
    const batch = ids.slice(offset, offset + BATCH_SIZE);
    const response = await api.post('/pending-actions/bulk-approve', { action_ids: batch }, {
      timeout: 120_000,
    });
    const items = response.data?.data?.results;
    if (!Array.isArray(items) || items.length !== batch.length
      || new Set(items.map((item) => item.action_id)).size !== batch.length
      || items.some((item) => !batch.includes(item.action_id) || typeof item.success !== 'boolean')) {
      throw new Error('Approval response was incomplete. Refresh before trying again.');
    }
    if (!isCurrent()) break;
    onBatch?.(items);
    results.push(...items);
    onProgress?.({ completed: results.length, total: ids.length });
  }
  const succeeded = results.filter((result) => result.success).length;
  return { results, succeeded, failed: results.length - succeeded };
}
